// src/belediye/pages/bildirimler/DuyuruOlusturPage.js
//
// FAZ-34 — Manuel duyuru gönderme. Erişim: bildirim.duyuru.gonder izni
// (route PermissionGate + backend scope-güvenli). v1: genel (broadcast) duyuru
// + opsiyonel zamanlama. Birim/rol hedefleme sonraki sürümde.

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PaperAirplaneIcon, CheckCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";

import { sendDuyuru } from "../../services/bildirimApi";
import { DUYURU_LEVELS as LEVELS } from "../../components/notifications/notificationMeta";
import "./DuyuruOlusturPage.css";

export default function DuyuruOlusturPage() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [level, setLevel] = useState("info");
  const [scheduled, setScheduled] = useState(false);
  const [scheduledFor, setScheduledFor] = useState("");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const canSubmit = title.trim().length > 0 && !sending;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setSending(true);
    setError("");
    setResult(null);
    try {
      const res = await sendDuyuru({
        type: "broadcast",
        title: title.trim(),
        body: body.trim(),
        level,
        scheduledFor: scheduled && scheduledFor ? new Date(scheduledFor).toISOString() : undefined,
      });
      setResult(res);
      setTitle("");
      setBody("");
      setScheduled(false);
      setScheduledFor("");
    } catch (err) {
      const data = err?.response?.data;
      const msg =
        (typeof data === "string" && data) ||
        data?.detail ||
        (data && typeof data === "object" && Object.values(data)?.[0]) ||
        err?.message ||
        "Duyuru gönderilemedi.";
      setError(String(Array.isArray(msg) ? msg[0] : msg));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="du-page">
      <div className="du-head">
        <h1 className="du-title">Duyuru Gönder</h1>
        <p className="du-sub">
          Tüm personele bildirim gönderin. İsterseniz ileri bir tarihe zamanlayın —
          zamanı gelince otomatik yayınlanır.
        </p>
      </div>

      {result ? (
        <div className="du-alert du-alert--ok">
          <CheckCircleIcon className="du-alert-icon" />
          <div>
            Duyuru {result?.scheduled ? "zamanlandı" : "gönderildi"} —{" "}
            <b>{result?.created ?? 0}</b> alıcı.
          </div>
        </div>
      ) : null}
      {error ? (
        <div className="du-alert du-alert--err">
          <ExclamationTriangleIcon className="du-alert-icon" />
          <div>{error}</div>
        </div>
      ) : null}

      <form className="du-card" onSubmit={onSubmit}>
        <label className="du-field">
          <span className="du-label">Başlık *</span>
          <input
            className="du-input"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            maxLength={160}
            placeholder="Örn: Sistem bakımı bu akşam 22:00'de"
          />
        </label>

        <label className="du-field">
          <span className="du-label">Mesaj</span>
          <textarea
            className="du-textarea"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            rows={4}
            placeholder="Detay (opsiyonel)"
          />
        </label>

        <label className="du-field">
          <span className="du-label">Önem</span>
          <select className="du-input" value={level} onChange={(e) => setLevel(e.target.value)}>
            {LEVELS.map((l) => (
              <option key={l.key} value={l.key}>
                {l.label}
              </option>
            ))}
          </select>
        </label>

        <label className="du-check">
          <input
            type="checkbox"
            checked={scheduled}
            onChange={(e) => setScheduled(e.target.checked)}
          />
          <span>İleri bir tarihe zamanla</span>
        </label>

        {scheduled ? (
          <label className="du-field">
            <span className="du-label">Yayın zamanı</span>
            <input
              className="du-input"
              type="datetime-local"
              value={scheduledFor}
              onChange={(e) => setScheduledFor(e.target.value)}
            />
          </label>
        ) : null}

        <div className="du-actions">
          <button type="button" className="du-btn du-btn--ghost" onClick={() => navigate(-1)}>
            Vazgeç
          </button>
          <button type="submit" className="du-btn du-btn--primary" disabled={!canSubmit}>
            <PaperAirplaneIcon className="du-btn-icon" />
            {sending ? "Gönderiliyor…" : scheduled ? "Zamanla" : "Gönder"}
          </button>
        </div>
      </form>
    </div>
  );
}
